$ = require 'jquery'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'app/scripts/views/card/card-limits-error'
PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ListBulkMoveCardsView extends View
  viewTitleKey: 'move all cards in list'

  events:
    'click .js-select-list': 'selectList'

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

    if @sendGASEvent
      Analytics.sendScreenEvent
        name: 'moveAllCardsInListInlineDialog',
        containers:
          list:
            id: @model?.id
          board:
            id: @model?.getBoard()?.id
          organization:
            id: @model?.getBoard()?.getOrganization()?.id

  render: ->
    data = @model.toJSON()
    data.lists = []

    lists = @model.getBoard().listList.models
    for list in lists
      _list = _.clone(list.toJSON())
      if _list.id == @model.id
        _list.current = true
      data.lists.push(_list)

    @$el.html(
      templates.fill(
        require('app/scripts/views/templates/list_bulk_card_move'),
        data
      )
    )

    @

  selectList: (e) ->
    $targetList = $(e.target).closest('.js-select-list')
    targetListId = $targetList.attr("name")

    return if $targetList.hasClass('disabled')

    listDest = @modelCache.get('List', targetListId)
    # Copy the original list, since moving the cards will cause the list to
    # change
    cards = _.clone(@model.openCards().models)

    if cards.length > 0
      options = {
        $elem: $(e.target),
        destinationList: listDest,
      }
      if maybeDisplayLimitsErrorOnCardAdd(options)
        return

      track("Card", "Moved in Bulk via List Menu")

      if @sendGASEvent
        Analytics.sendTrackEvent
          action: 'moved',
          actionSubject: 'card',
          source: 'moveAllCardsInListInlineDialog'
          attributes:
            listSourceId: @model?.id || ''
          containers:
            list:
              id: targetListId || ''
            board:
              id: @model?.getBoard()?.id || ''
            organization:
              id: @model?.getBoard()?.getOrganization()?.id || ''

      for card in cards
        card.moveToList listDest, 1000

    PopOver.hide()

    return
